export default "assets/images/icons/phone-70c6a5d6.svg";